import { CircleAlert } from 'lucide-react'
import { useAuth, type AuthErrorKind } from '../auth/context'
import { Button } from '../components/Button'
import { getWebApp, isInTelegram } from '../telegram'
import { AuthLayout } from './AuthLayout'

const TEXT: Record<AuthErrorKind, [string, string]> = {
  network: ['Сервер не отвечает', 'Проверьте соединение и попробуйте ещё раз.'],
  expired: ['Сессия устарела', 'Закройте приложение и откройте его снова из бота.'],
  bad_signature: ['Не удалось войти', 'Telegram не подтвердил вход. Откройте приложение заново из бота.'],
  session: ['Сессия закончилась', 'Нужно войти заново.'],
  unknown: ['Что-то пошло не так', 'Попробуйте ещё раз.'],
}

export function ErrorScreen({ kind }: { kind: AuthErrorKind }) {
  const { retry } = useAuth()
  const [title, text] = TEXT[kind]

  return (
    <AuthLayout>
      <div className="flex flex-col items-center text-center">
        <span className="mb-3 inline-flex size-11 items-center justify-center rounded-xl bg-surface text-muted ring-1 ring-line ring-inset">
          <CircleAlert size={20} />
        </span>
        <h1 className="page-title">{title}</h1>
        <p className="mt-1 text-sm text-pretty text-muted">{text}</p>
        <div className="mt-6 flex gap-2">
          <Button variant="primary" onClick={retry}>
            Повторить
          </Button>
          {isInTelegram() && <Button onClick={() => getWebApp()?.close()}>Закрыть</Button>}
        </div>
      </div>
    </AuthLayout>
  )
}
